import { Link, Typography } from '@mui/material';

type Props = {
  label: string;
  values: string[];
};

export default function SectionLinkRow({ label, values }: Props) {
  return (
    <div className="section-row">
      <Typography variant="h4">{label}</Typography>
      {values.map((value, index) => (
        <Link
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          href={value}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontSize: theme => theme.typography.body2.fontSize,
            color: theme => theme.palette.primary.main,
          }}>
          {value}
        </Link>
      ))}
    </div>
  );
}
